<template>
  <b-modal
    id="PtoModal"
    :title="$t('amount')"
    size="md"
    centered
    :ok-title="$t('send')"
    :cancel-title="$t('general.cancel')"
    @ok.prevent="ok"
    @hidden="hidden"
  >

    <validation-observer ref="ptoValidation">
      <b-form-group
        :label="$t('amount')"
        label-for="pto_input"
      >
        <validation-provider
          #default="{ errors }"
          rules="required"
          :name="$t('amount')"
        >
          <b-form-input
            id="pto_input"
            v-model="quantity"
            type="number"
            :placeholder="$t('amount')"
            :state="validateState(errors)"
            name="reset-password-login"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormInput,
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

export default {
  components: {
    BModal,
    BFormInput,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    isPto: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    quantity: null,
    required,
  }),
  methods: {
    validateState(errors) {
      if (this.quantity > this.data.remainder) {
        setTimeout(() => {
          if (!this.$refs.ptoValidation.errors[this.$t('amount')].length) {
            this.$refs.ptoValidation.errors[this.$t('amount')].push('Такого количества нет на складе')
          }
        }, 100)
        return false
      }
      return errors.length > 0 ? false : null
    },
    ok() {
      this.$refs.ptoValidation.validate()
        .then(success => {
          if (!success) return
          if (this.quantity > this.data.remainder) return
          this.$emit('onSend', this.quantity)
        })
    },
    hidden() {
      this.quantity = null
    },
  },
}
</script>

<style>

</style>
